import api from "./api";

export const collectionService = {
  async getSamities() {
    const response = await api.get("/collections/samities");
    return response.data;
  },

  async getDueList(samityId, collectionDate) {
    const response = await api.get("/collections/due-list", {
      params: { samity_id: samityId, collection_date: collectionDate },
    });
    return response.data;
  },

  async createDailyCollection(collectionData) {
    const response = await api.post("/collections/daily-sheet", collectionData);
    return response.data;
  },

  async getCollectionSheets(params = {}) {
    const response = await api.get("/collections/sheets", { params });
    return response.data;
  },

  async getCollectionSheetDetails(id) {
    const response = await api.get(`/collections/sheets/${id}`);
    return response.data;
  },

  async submitCollection(id, submissionData) {
    const response = await api.put(`/collections/${id}/submit`, submissionData);
    return response.data;
  },

  async getDailyCollections(params = {}) {
    const response = await api.get("/collections/daily", { params });
    return response.data;
  },

  async getCollectionDetails(id) {
    const response = await api.get(`/collections/${id}`);
    return response.data;
  },

  async getOfficerPerformance(officerId, fromDate, toDate) {
    const response = await api.get(
      `/collections/officer/${officerId}/performance`,
      {
        params: { from_date: fromDate, to_date: toDate },
      },
    );
    return response.data;
  },
};
